import React from 'react';
import { useSubtramiteForm } from '../../../hooks/useSubtramiteForm';
import { saveEstudioResultado } from '../../../services/tramiteService';
import SubtramiteForm from '../../SubtramiteForm';
import { useAuthorization } from '@/auth/hooks/useAuthorization';
import { withRequiredTramite } from './withRequiredTramite';

const EstudioResultado: React.FC = () => {
  const {
    data,
    loading,
    init,
    isUpdate,
    setIsUpdate,
    handleChange,
    handleSubmit,
    handleFinalizarSubtramite,
    handleReabrirSubtramite
  } = useSubtramiteForm({
    subtramiteKey: 'estudiotitulo',
    defaultData: {
      estudiotitulo: null,
      estudio_titulo_path: null,
    },
    saveFunction: saveEstudioResultado,
    successMessage: 'Resultado de Estudio de Título Guardado con éxito',
    errorTitle: 'Error al grabar Resultado de Estudio de Título',
  });

  const { canUploadEstudioTitulo } = useAuthorization();

  // Configuración de campos básicos
  const fields = [
    {
      type: 'toggle',
      name: 'habilitado',
      label: 'Habilitado:',
      inline: true,
      visible: canUploadEstudioTitulo && !isUpdate,
    },
    {
      type: 'date',
      name: 'fecini',
      label: 'Fecha de inicio:',
      inline: true,
      visible: canUploadEstudioTitulo && !isUpdate,
    },
  ];

  // Configuración de campos de archivos
  const fileFields = [
    {
      type: 'file',
      name: 'estudiotitulo',
      pathField: 'estudio_titulo_path',
      label: 'Resultado:',
      inline: true,
      visible: isUpdate,
      readOnly: !canUploadEstudioTitulo,
      helpText: 'Archivo del resultado del estudio de título'
    },
  ];

  const btnGuardarVisible = fields.some(field => field.visible) ||
    fileFields.some(field => field.visible && !field.readOnly);



  return (
    <SubtramiteForm
      title={"Resultado"}
      data={data}
      loading={loading}
      init={init}
      isUpdate={isUpdate}
      editShow={canUploadEstudioTitulo}
      setIsUpdate={setIsUpdate}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleFinalizarSubtramite={handleFinalizarSubtramite}
      handleReabrirSubtramite={handleReabrirSubtramite}
      btnGuardarVisible={btnGuardarVisible}
      fields={fields}
      fileFields={fileFields}
      subtramiteKey="estudiotitulo"
    />
  );
}

export default withRequiredTramite(EstudioResultado);